
export default {
    props: ['error'],
    data() {
        return {
            time: '5',
            time_end: null
        }
    },
    methods: {
        GoIndex() {
           
            let _t = 4;
            this.time_end = setInterval(() => {
                //如果不等于 0
                if (_t !== 0) {
                   
                    this.time = _t--;
                } else {
                    this.$router.replace('/')
                    clearTimeout(this.time_end)
                    this.time_end = null
                }
            }, 1000)
        }
    },

    created() {
        this.GoIndex()
    },
    destroyed() {
        
        clearTimeout(this.time_end)
        this.time_end = null
    },

}
